import { ExportChain } from "../../types/sales-report-export.type";
import { CUSTOMER_GROUP_EXPORT_FORMAT_LABEL } from "../../types/customer-group-export.type";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import Typography from "@mui/material/Typography";

interface CustomerGroupSelectorProps {
  chains: ExportChain[];
  selectedUuid: string | null;
  onSelect: (chain: ExportChain) => void;
}

interface ChainCardProps {
  chain: ExportChain;
  isSelected: boolean;
  onSelect: (chain: ExportChain) => void;
}

function ChainCard({ chain, isSelected, onSelect }: Readonly<ChainCardProps>) {
  const handleClick = () => onSelect(chain);

  return (
    <Card
      sx={{
        boxShadow: "none",
        borderRadius: "12px",
        border: "1px solid",
        borderColor: isSelected ? "primary.main" : "divider",
        bgcolor: isSelected ? "action.selected" : "background.paper",
      }}
    >
      <CardActionArea
        onClick={handleClick}
        sx={{
          p: 2,
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 0.5,
        }}
      >
        <Typography
          variant="subtitle1"
          fontWeight={600}
          textAlign="center"
          color={isSelected ? "primary.main" : "text.primary"}
        >
          {chain.name}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          รูปแบบไฟล์ {CUSTOMER_GROUP_EXPORT_FORMAT_LABEL[chain.export_format]}
        </Typography>
      </CardActionArea>
    </Card>
  );
}

/** The chains MASTER set up for export (ตั้งค่าระบบ → ตั้งค่า export เชน MT), one card each. */
export default function CustomerGroupSelector({
  chains,
  selectedUuid,
  onSelect,
}: Readonly<CustomerGroupSelectorProps>) {
  if (chains.length === 0) {
    return (
      <Typography color="text.secondary">
        ยังไม่มีเชนที่ตั้งค่า export ไว้
      </Typography>
    );
  }

  return (
    <Box
      sx={{
        display: "grid",
        gap: 2,
        gridTemplateColumns: {
          xs: "repeat(2, minmax(0, 1fr))",
          sm: "repeat(4, minmax(0, 1fr))",
        },
      }}
    >
      {chains.map((chain) => (
        <ChainCard
          key={chain.uuid}
          chain={chain}
          isSelected={chain.uuid === selectedUuid}
          onSelect={onSelect}
        />
      ))}
    </Box>
  );
}
